const isMultisite = WCBT_GLOBAL_OBJECT.is_multisite || false;
const blogId = WCBT_GLOBAL_OBJECT.blog_id || '';

export const setCookie = ( name, value, expiredDay = 0, expireHour = 0 ) => {
	const date = new Date();
	date.setTime( date.getTime() + ( expiredDay * 24 * 60 * 60 * 1000 ) + ( expireHour * 60 * 60 * 1000 ) );
	const expires = 'expires=' + date.toUTCString();

	if ( isMultisite ) {
		name = `${ name }_${ blogId }`;
	}
	document.cookie = `${ name }=${ value };${ expires };path=/`;
};

export const getCookie = ( name ) => {
	if ( isMultisite ) {
		name = `${ name }_${ blogId }`;
	}
	name += '=';
	const decodedCookie = decodeURIComponent( document.cookie );
	const ca = decodedCookie.split( ';' );
	for ( let i = 0; i < ca.length; i++ ) {
		let c = ca[ i ];
		while ( c.charAt( 0 ) === ' ' ) {
			c = c.substring( 1 );
		}
		if ( c.indexOf( name ) === 0 ) {
			return c.substring( name.length, c.length );
		}
	}

	return '';
};

export const deleteCookie = ( name ) => {
	const date = new Date();
	date.setTime( date.getTime() - 9999 );
	const expires = 'expires=' + date.toUTCString();

	if ( isMultisite ) {
		name = `${ name }_${ blogId }`;
	}

	document.cookie = `${ name }='';${ expires };path=/`;
};
